import React, { useState,useEffect } from "react";
import axios from "axios";
import { FaSearch } from "react-icons/fa";
import { Modal, Spin } from 'antd';


const ApplyForJobs = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const jobsPerPage = 6;
  const [jobOpportunities, setJobOpportunities] = useState([]);
  const [selectedJob, setSelectedJob] = useState(null);
  const apiUrl = import.meta.env.VITE_API_URL; // API Base URL
  const [submitting, setSubmitting] = useState(false);


  useEffect(() => {
      axios.get(`${apiUrl}/jobs/`)
          .then((response) => {
            setJobOpportunities(response.data);
          })
          .catch((error) => {
              console.error("Error fetching jobs:", error);
          });
  }, []);
  
  useEffect(() => {
    if (selectedJob) {
      setFormState((prevState) => ({
        ...prevState,
        Job: `${selectedJob.title} in ${selectedJob.country}`,
      }));
    }
  }, [selectedJob]);
  



  const handleApply = (job) => {
    setSelectedJob(job);
  };
  
  useEffect(() => {
    if (selectedJob) {
      document.getElementById("apply-now-form").scrollIntoView({ behavior: "smooth" });
    }
  }, [selectedJob]);
  

  const filteredJobs = jobOpportunities.filter(
    (job) =>
      job.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      job.city.toLowerCase().includes(searchTerm.toLowerCase()) ||
      job.country.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const indexOfLastJob = currentPage * jobsPerPage;
  const indexOfFirstJob = indexOfLastJob - jobsPerPage;
  const currentJobs = filteredJobs.slice(indexOfFirstJob, indexOfLastJob);

  const totalPages = Math.ceil(filteredJobs.length / jobsPerPage);
  const [formFields, setFormFields] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [formState, setFormState] = useState({}); // State to store form data

  // Fetch form fields from the API
  useEffect(() => {
    const fetchFormFields = async () => {
      try {
        const response = await axios.get(`${apiUrl}/forms/4`);
        setFormFields(response.data.fields || []);
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching form fields:", error);
        setIsLoading(false);
      }
    };

    fetchFormFields();
  }, [apiUrl]);

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    let formData = new FormData();
  
    formData.append("form_id", 4);
    formFields.forEach((field) => {
      const fieldValue = formState[field.name];
  
      if ((field.field_type === "image" || field.field_type === "file") && formState[field.name]) {
        const file = formState[field.name][0];
        formData.append(`file_${field.id}`, file);
        formData.append(`field_${field.id}`, "");
      } else if (fieldValue || field.field_type === "checkbox" || field.field_type === "radio") {
        formData.append(`field_${field.id}`, fieldValue || "");
      }
    });
  
    try {
      const response = await axios.post(`${apiUrl}/form_responses/submit/`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      console.log("Form submitted successfully:", response.data);
      Modal.success({
        title: 'Application Submitted!',
        content: 'Your job application has been submitted successfully.',
      });
      setFormState({});
      setSelectedJob(null);
    } catch (error) {
      console.error("Error submitting form:", error);
      Modal.error({
        title: 'Submission Failed',
        content: 'There was an error submitting the form. Please try again.',
      });
    } finally {
      setSubmitting(false);
    }
  };
  
  
  
  const handleInputChange = (e) => {
    const { name, value, type, files, checked } = e.target;
    if (type === "checkbox") {
      setFormState((prev) => ({
        ...prev,
        [name]: prev[name]
          ? checked
            ? [...prev[name], value]
            : prev[name].filter((v) => v !== value)
          : checked
          ? [value]
          : [],
      }));
    } else if (type === "radio") {
      setFormState((prev) => ({ ...prev, [name]: value }));
    } else if (type === "file") {
      setFormState((prev) => ({ ...prev, [name]: files }));
    } else {
      setFormState((prev) => ({ ...prev, [name]: value }));
    }
  };


  return (
    <div className="bg-black min-h-screen py-10 px-5">
      <div className="text-center mb-10">
        <h1 className="text-4xl font-semibold text-white">Worker Registration & Job Opportunities</h1>
        <p className="text-gray-300 max-w-2xl mx-auto">
          Browse exciting job opportunities abroad and apply for the one that fits your skills and aspirations.
        </p>
      </div>

      {/* <div className="flex mb-8 justify-center relative">
        <FaSearch className="absolute left-12 top-1/2 transform -translate-y-1/2 text-[#e6b800] w-5 h-5" />
        <input
          type="text"
          className="w-full max-w-lg px-4 py-2 pl-10 border bg-black text-[#e6b800] border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#e6b800] placeholder-[#e6b800]"
          placeholder="Search for jobs..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div> */}

      <div className="mt-10 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {currentJobs.map((job) => (
          <div
            key={job.id}
            className="bg-[#2c2c2c] p-6 rounded-lg shadow-lg border-2 border-[#e6b800] hover:bg-[#444444] transition duration-300"
          >
            <h2 className="text-2xl font-semibold text-white mb-2">{job.title}</h2>
            <p className="text-gray-300">
              <strong>Location:</strong> {job.city}, {job.country}
            </p>
            <p className="text-gray-300"><strong>Industry:</strong> {job.industry}</p>
            <p className="text-gray-300 mb-4"><strong>Requirements:</strong> {job.requirements}</p>
            <button
              onClick={() => handleApply(job)}
              className="w-full bg-[#e6b800] text-black py-2 rounded-lg font-semibold hover:bg-black hover:text-[#e6b800] border-2 border-[#e6b800] transition duration-300"
            >
              Apply Now
            </button>
          </div>
        ))}
      </div>

      <div className="flex justify-center mt-8">
        <button
          onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
          disabled={currentPage === 1}
          className="px-4 py-2 bg-[#e6b800] text-black rounded-lg disabled:opacity-50"
        >
          Previous
        </button>
        <span className="mx-4 text-white">{currentPage} / {totalPages}</span>
        <button
          onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
          disabled={currentPage === totalPages}
          className="px-4 py-2 bg-[#e6b800] text-black rounded-lg disabled:opacity-50"
        >
          Next
        </button>
      </div>


      {selectedJob && (
        
        <div className="grid grid-cols-1 lg:grid-cols-2 mt-16 gap-8 lg:max-w-6xl lg:mx-auto">
                      <h2 className="lg:col-span-2 text-3xl  lg:text-5xl font-semibold text-center text-white mb-6">Apply for {selectedJob.title} at {selectedJob.country}</h2>

          <div className="flex-1 bg-white p-8 rounded-lg shadow-lg border-t-8 border-[#e6b800]">
          <h2 className="text-3xl font-semibold text-center text-black mb-6">Apply Now</h2>

            <form className="space-y-6" id ="apply-now-form" onSubmit={handleSubmit}>
            {formFields.map((field, index) => (
              <div key={index}>
                <label
                  className="block text-black font-medium mb-2"
                  htmlFor={field.name}
                >
                  {field.name}
                  {field.required && <span className="text-red-500"> *</span>}
                </label>

                {/* Handle text and email fields */}
                 {/* Handle text and email fields */}

                 {field.field_type === "text" && field.name === "Job" && (
   <input
     type="text"
     name={field.name}
     id={field.name}
     className="w-full bg-gray-300 border-4 border-alf font-bold text-black px-4 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#e6b800]"
     value={selectedJob ? `${selectedJob.title} in ${selectedJob.country}` : ""}
     readOnly
   />
)}

    {field.field_type === "text" && field.name !== "Job" && (
      <input
        type="text"
        name={field.name}
        id={field.name}
        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#e6b800]"
        placeholder={`Enter your ${field.name}`}
        required={field.required}
        value={formState[field.name] || ""}
        onChange={handleInputChange}
      />
    )}
                {field.field_type === "email" && (
                  <input
                    type="email"
                    name={field.name}
                    id={field.name}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#e6b800]"
                    placeholder={`Enter your ${field.name}`}
                    required={field.required}
                    value={formState[field.name] || ""}
                    onChange={handleInputChange}
                  />
                )}
                
                 

                {/* Handle phone number input */}
                {field.field_type === "phone" && (
                  <input
                    type="tel"
                    name={field.name}
                    id={field.name}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#e6b800]"
                    placeholder={`Enter your ${field.name}`}
                    required={field.required}
                    value={formState[field.name] || ""}
                    onChange={handleInputChange}
                  />
                )}

                {/* Handle image upload (file input) */}
                {(field.field_type === "image" || field.field_type === "file") && (
                  <input
                    type="file"
                    name={field.name}
                    id={field.name}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#e6b800]"
                    required={field.required}
                    onChange={handleInputChange}
                  />
                )}

                {/* Handle text area */}
                {field.field_type === "textarea" && (
                  <textarea
                    name={field.name}
                    id={field.name}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#e6b800]"
                    placeholder={`Enter your ${field.name}`}
                    rows="3"
                    required={field.required}
                    value={formState[field.name] || ""}
                    onChange={handleInputChange}
                  ></textarea>
                )}

                {/* Handle choice (checkbox) */}
                {field.field_type === "checkbox" && (
                  <div className="flex flex-wrap  items-center gap-10 justify-center ">
                    {field.options &&
                      field.options.map((option, i) => (
                        <label key={i} className="flex items-center ">
                          <input
                            type="checkbox"
                            name={field.name}
                            value={option}
                            checked={formState[field.name]?.includes(option)}
                            onChange={handleInputChange}
                            className="text-[#e6b800] border-gray-300 rounded focus:ring-2 focus:ring-[#e6b800]"
                          />
                          <span className="text-gray-700 focus:bg-alf" >{option}</span>
                        </label>
                      ))}
                  </div>
                )}

                {/* Handle choice (radio) */}
                {field.field_type === "radio" && (
                  <div className="space-y-2">
                    {field.options &&
                      field.options.map((option, i) => (
                        <label key={i} className="flex items-center space-x-2">
                          <input
                            type="radio"
                            name={field.name}
                            value={option}
                            checked={formState[field.name] === option}
                            onChange={handleInputChange}
                            className="text-[#e6b800] border-gray-300  focus:ring-2 focus:ring-[#e6b800]"
                          />
                          <span className="text-gray-700">{option}</span>
                        </label>
                      ))}
                  </div>
                )}

                {/* Handle select dropdown */}
                {field.field_type === "select" && (
                  <select
                    name={field.name}
                    id={field.name}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#e6b800]"
                    required={field.required}
                    value={formState[field.name] || ""}
                    onChange={handleInputChange}
                  >
                    <option value="">Select {field.name}</option>
                    {field.options &&
                      field.options.map((option, i) => (
                        <option key={i} value={option}>
                          {option}
                        </option>
                      ))}
                  </select>
                )}
              </div>
            ))}

<button
  type="submit"
  disabled={submitting}
  className="w-full bg-[#e6b800] text-black py-2 rounded-lg font-semibold hover:bg-black hover:text-[#e6b800] border-2 border-[#e6b800] transition duration-300 flex justify-center items-center gap-2"
>
  {submitting ? (
    <>
      <Spin size="small" />
      Submitting...
    </>
  ) : (
    "Submit"
  )}
</button>


          </form>
          </div>
          <div className="poster-preview">
              <img src={selectedJob.poster} alt={selectedJob.title} className="poster-image h-full rounded-lg" />
           </div>
          
        </div>
      )}
    </div>
  );
};

export default ApplyForJobs;
